import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from './Navbar';

export function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ef04ff8959f2e4b5f69f9b8f647e8896.jpg"
          alt="On Target Prints - Game Day Atmosphere"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <Navbar />

      {/* Logo Branding Area */}
      <div className={`relative flex justify-center pt-28 pb-6 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
        <Link to="/">
          <img
            src="https://public.readdy.ai/ai/img_res/a4aeee0d-6a26-4433-b892-d38374e82571.png"
            alt="Starkvegas Threads by On Target Print Solutions"
            style={{
              height: '220px',
              width: 'auto',
              display: 'block',
              imageRendering: 'high-quality',
              filter: 'drop-shadow(0 0 0.5px white) drop-shadow(0 0 0.5px white) drop-shadow(0 0 0.5px white)',
            }}
          />
        </Link>
      </div>

      {/* Divider */}
      <div className="relative flex justify-center mb-2">
        <div className="w-16 h-px bg-white/30"></div>
      </div>

      {/* Hero Content */}
      <div className="relative flex-1 flex items-center justify-center text-center px-6 pb-16 pt-8">
        <div className={`max-w-4xl w-full transition-all duration-1000 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm border border-white/30 rounded-full text-white text-sm font-semibold mb-8">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            Printed Locally in Starkville, MS
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 leading-tight tracking-tight">
            Design Your Own<br />
            <span className="text-red-300">Mississippi State</span> Gear
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-10 font-medium max-w-2xl mx-auto leading-relaxed">
            Create custom Bulldogs shirts in seconds.<br className="hidden md:block" />
            Printed locally in Starkville.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to="/customize"
              className="px-8 py-4 bg-[#6B0000] text-white text-base font-bold rounded-xl hover:bg-[#850000] transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-edit-2-line"></i>
              </div>
              Design Your Shirt
            </Link>
            <Link
              to="/shop"
              className="px-8 py-4 bg-white text-gray-900 text-base font-bold rounded-xl hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-store-2-line"></i>
              </div>
              Shop Bulldogs Tees
            </Link>
          </div>

          {/* Social proof bar */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-white/80 text-sm">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="font-semibold">4.9/5 from 400+ reviews</span>
            </div>
            <span className="hidden sm:block text-white/30">|</span>
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-timer-flash-line text-green-400"></i>
              </div>
              <span>2–3 day turnaround</span>
            </div>
            <span className="hidden sm:block text-white/30">|</span>
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-red-300"></i>
              </div>
              <span>Local Starkville shop</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="relative flex justify-center pb-8 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </div>
  );
}
